const bg = {
  common: {
    bookMeeting: "Насрочете среща",
    requestDemo: "Заявете демонстрация",
    languageSelectorLabel: "Избор на език",
    languageNames: {
      en: "Английски",
      bg: "Български",
    },
    logoAlt: "Лого на Warenex",
    navigationLogoAlt: "Навигационно лого на Warenex",
    serviceIconAlt: "Услуга",
    carouselItemAlt: "Избрана силна страна на компанията",
    previousSlide: "Предишна силна страна",
    nextSlide: "Следваща силна страна",
    openMenu: "Отворете менюто",
    closeMenu: "Затворете менюто",
    loadingImage: "Зареждане на изображение",
  },
  navigation: {
    home: "Начало",
    services: "Услуги",
    technologies: "Технологии",
    aboutUs: "За нас",
    products: "Продукти",
    wecpDescription: "Платформа за електронна търговия на Warenex",
    contactUs: "Свържете се с нас",
  },
  home: {
    hero: {
      title: "СЪЗДАВАМЕ БЪДЕЩЕТО",
      subtitle: "ВАШИЯТ УСПЕХ Е НАШАТА МИСИЯ",
      values: [
        "ПРОФЕСИОНАЛИЗЪМ И ОТДАДЕНОСТ",
        "ВИСОКОКВАЛИФИЦИРАН ЕКИП",
        "ПРИЯТЕЛСКО ОТНОШЕНИЕ",
      ],
    },
    services: {
      title: "КАКВО ДА ОЧАКВАТЕ",
      paragraphs: [
        "Ясен и плавен процес от началото до края, с внимание към всеки детайл, открита комуникация и фокус върху това да останете доволни от резултата.",
        "Работата с нас е повече от получаването на готов продукт. До себе си имате надежден партньор, който превръща идеите ви в работещо решение точно както сте го замислили.",
      ],
      items: [
        {
          title: "КОНСУЛТИРАНЕ",
          description:
            "Анализираме нуждите, уточняваме целите и планираме целия процес, за да поставим проекта на стабилна основа.",
        },
        {
          title: "ДИЗАЙН",
          description:
            "Създаваме красиви и интуитивни интерфейси, които работят отлично на различни устройства.",
        },
        {
          title: "РАЗРАБОТКА",
          description:
            "Използваме съвременни технологии, за да изградим бързи и надеждни софтуерни решения според вашите нужди.",
        },
        {
          title: "ТЕСТВАНЕ",
          description:
            "Откриваме потенциалните проблеми навреме и проверяваме дали софтуерът отговаря на поставените изисквания.",
        },
        {
          title: "ПОДДРЪЖКА",
          description:
            "Грижим се софтуерът ви да работи стабилно, актуализираме го при нужда и отстраняваме възникнали проблеми.",
        },
      ],
    },
    testimonials: {
      title: "КАКВО НИ МОТИВИРА",
      items: [
        "Работата с Warenex беше истинско удоволствие за нас. Системата за управление на служители, която изградиха, надмина очакванията ни във всяко отношение. Изключително доволни сме от резултата.",
        "Решението да поверим редизайна на сайта си на Warenex се оказа отличен избор. Новият дизайн е не само впечатляващ, но и работи безупречно на различни устройства. Получихме безброй комплименти от клиентите си.",
      ],
    },
    achievements: {
      title: "Умни решения с реални резултати",
      items: [
        {
          title: "Платформа Smart Foodie",
          description:
            "Smart Foodie е цялостна и лесна за използване платформа с уеб и мобилно приложение, създадена за ресторантьорския бизнес. Клиентите могат удобно да резервират маса и да поръчват директно от телефона си, а посещението на ресторант става по-лесно и приятно.",
        },
        {
          title: "Глобална система за автомобилни търгове",
          description:
            "Системата дава достъп до глобална платформа за автомобилни търгове, където продавачите лесно публикуват своите превозни средства. Добавихме и логистичен модул, с който партньорите ни управляват доставките на автомобили лесно и организирано.",
        },
        {
          title: "Уебсайт на Modern House",
          description:
            "Създадохме удобен уебсайт, съобразен с нуждите на нашия партньор. От индивидуалната визия до лесната навигация, фокусът ни беше клиентите да разглеждат безпроблемно къщи и метални конструкции онлайн.",
        },
      ],
    },
    strengths: {
      title: "НАШИТЕ СИЛНИ СТРАНИ",
      items: [
        {
          heading: "ЕКСПЕРТНОСТ",
          text: "Развиваме знанията си постоянно и следим най-новите технологии и тенденции в ИТ сектора.",
        },
        {
          heading: "ОТГОВОРНОСТ",
          text: "Поемаме пълна отговорност за успеха на проектите ви и работим открито и прозрачно.",
        },
        {
          heading: "ЕКИПНОСТ",
          text: "Екипната работа е в основата на компанията ни. Споделяме идеи, умения и опит, за да се развиваме заедно.",
        },
        {
          heading: "ПРОФЕСИОНАЛИЗЪМ",
          text: "Поддържаме високи стандарти за качество, етика и комуникация във всичко, което правим.",
        },
      ],
    },
    contact: {
      title: "СПОДЕЛЕТЕ ИДЕЯТА СИ С НАС",
      directContactTitle: "ИЛИ СЕ СВЪРЖЕТЕ ДИРЕКТНО С НАС",
      phoneHeading: "Обадете ни се",
      phoneText:
        "Обадете ни се, за да обсъдим директно с екипа ни от какво имате нужда.",
      emailHeading: "Изпратете ни имейл",
      emailText:
        "Пишете ни по имейл и ще получите подробен отговор на въпросите си.",
    },
  },
  about: {
    titleBefore: "Няколко думи",
    titleHighlight: "за нас",
    introBefore: "Ние сме софтуерна компания, която създава ",
    introHighlight: "иновативни",
    introAfter:
      " технологични решения. Специализираме в разработката на софтуер по поръчка.",
    companyPrefix: "В ",
    companySuffix:
      " знаем, че всеки бизнес има свои специфични нужди. Затова работим в тясно сътрудничество с клиентите си, опознаваме изискванията им и създаваме решения, които им помагат да постигнат целите си.",
    imageAlt: "Представяне на екипа на Warenex",
    values: [
      "Стремим се да изграждаме дългосрочни отношения с клиентите си. Мисията ни е да предлагаме обслужване, което надхвърля очакванията им и допринася за успеха на техния бизнес.",
      "Вярваме, че нашият успех е пряко свързан с успеха на клиентите ни. Затова полагаме допълнителни усилия, за да създаваме качествени решения, съобразени с конкретните им нужди.",
      "Разработваме софтуер в тясно сътрудничество с клиентите си. Поддържаме постоянна комуникация и търсим обратна връзка, за да сме сигурни, че резултатът отговаря на очакванията им.",
      "Искате да научите повече за услугите ни или за начина, по който можем да помогнем на бизнеса ви? Свържете се с нас. Ще се радваме да обсъдим възможностите за съвместна работа.",
    ],
  },
  servicesPage: {
    titleBefore: "Превърнете идеята си в реалност с нашите ",
    titleHighlight: "услуги",
    intro:
      "В Warenex създаваме ефективни софтуерни решения, които подпомагат развитието на бизнеса ви. Разработваме качествени уебсайтове и мобилни приложения, съчетани с отличен дизайн и прецизно тестване. Оставете техническата част на нас, за да се съсредоточите върху успеха на своя бизнес.",
    imageAlt: "Софтуерни услуги от Warenex",
    items: [
      {
        title: "Уеб разработка",
        description:
          "Изграждаме бързи и адаптивни уебсайтове със съвременни технологии. Помагаме ви да създадете силно онлайн присъствие, което достига до точната аудитория и задържа нейния интерес.",
      },
      {
        title: "Мобилна разработка",
        description:
          "Създаваме интуитивни и удобни мобилни приложения за iOS и Android. Така бизнесът ви остава лесно достъпен за клиентите, където и да се намират.",
      },
      {
        title: "UX/UI дизайн",
        description:
          "Проектираме красиви и ориентирани към потребителя интерфейси, които са лесни за работа. Съчетаваме функционалност и естетика, за да превърнем всеки дигитален продукт в приятно изживяване.",
      },
      {
        title: "QA тестване",
        description:
          "Проверяваме надеждността, сигурността и производителността на софтуера ви. Откриваме и отстраняваме потенциални проблеми, преди да достигнат до потребителите.",
      },
    ],
  },
  technologiesPage: {
    titleBefore: "Вярваме в бъдещето на",
    titleHighlight: "технологиите",
    intro:
      "Следим най-новите и доказани технологии в индустрията. Подбираме правилните инструменти за всеки проект, за да създаваме качествени, ефективни и устойчиви софтуерни решения. По-долу ще откриете технологиите, с които превръщаме идеите ви в работещи продукти.",
    imageAlt: "Софтуерни технологии, използвани от Warenex",
    exploreButton: "КАКВО ИЗПОЛЗВАМЕ",
    categories: {
      frontEnd: "Front-end",
      backEnd: "Back-end",
      devOps: "DevOps",
      mobile: "Мобилни технологии",
      other: "Други",
    },
  },
  wecp: {
    hero: {
      title: "По-умна платформа за електронна търговия, създадена за растеж",
      description:
        "WECP помага на бизнеса да продава онлайн, да управлява ежедневните си операции и да предлага удобно пазаруване на всяко устройство.",
      highlightsLabel: "Основни предимства на платформата",
      highlights: [
        "Проектирана да обработва голям обем данни и да обслужва голям брой едновременни потребители",
        "Сигурна",
        "Лесна за работа",
      ],
      imageAlt:
        "Административен панел и мобилен онлайн магазин в платформата WECP",
    },
    advantages: {
      eyebrow: "Създадена за реални резултати",
      title: "Защо екипите избират WECP",
      items: [
        {
          title: "Удобна за потребителите",
          description:
            "Модерни и адаптивни онлайн магазини, които осигуряват удобно пазаруване на всяко устройство.",
        },
        {
          title: "Висока производителност",
          description:
            "Платформата реагира бързо, а разглеждането и работата с магазина остават плавни и удобни.",
        },
        {
          title: "Сигурна и надеждна",
          description:
            "Защитени клиентски профили и администраторски достъп, с надеждна работа във всекидневието.",
        },
        {
          title: "Гъвкава и адаптивна",
          description:
            "Настройте каталога, визията, началната страница и фирмената информация според своя бранд.",
        },
        {
          title: "Ясен поглед върху продажбите",
          description:
            "Следете продажби, поръчки, средна стойност на поръчката, продадени артикули и клиентски тенденции от едно табло.",
        },
        {
          title: "Готова за различни пазари",
          description:
            "Управлявайте езици, преведено каталожно съдържание и валути от административния панел.",
        },
      ],
    },
    connectedCommerce: {
      eyebrow: "Една платформа за клиенти и екипи",
      title: "Онлайн магазинът и управлението му работят заедно",
      description:
        "Клиентите получават удобно пазаруване, а екипът ви управлява продуктите, визията и всичко след поръчката от едно място.",
      points: [
        "Удобен магазин за клиентите",
        "Ясен административен панел",
        "Създадена за ежедневната търговия",
      ],
      storefront: "Онлайн магазин",
      searchCatalog: "Търсене в каталога",
      productGroups: ["Нови предложения", "Популярни продукти", "Препоръчани"],
      adminWorkspace: "Административен панел",
      orders: "Поръчки",
      inventory: "Наличности",
      customers: "Клиенти",
      salesOverview: "Преглед на продажбите",
    },
    capabilities: {
      eyebrow: "Създадена за реалната работа на магазина",
      title: "Инструментите зад един по-добър онлайн магазин",
      description:
        "WECP обединява всичко, което виждат клиентите, с ежедневното управление на магазина в един свързан продукт.",
      areas: [
        {
          title: "Онлайн магазин, в който клиентите се ориентират лесно",
          description:
            "Помогнете на купувачите да открият подходящия продукт, да сравнят вариантите и уверено да стигнат до поръчка.",
          features: [
            "Адаптивен каталог с търсене, сортиране и подробни филтри",
            "Продуктови варианти, любими продукти, отзиви и свързани предложения",
            "Количка за гости и регистрирани клиенти с ясен процес на поръчка",
          ],
        },
        {
          title: "Всичко за ежедневната работа на едно място",
          description:
            "Дайте на екипа си подредено работно пространство за задачите, които движат онлайн магазина.",
          features: [
            "Продукти, категории, марки, характеристики и варианти",
            "Наличности, поръчки, клиенти и съобщения за контакт",
            "Справки за продажбите и клиентите за избран период",
          ],
        },
        {
          title: "Магазин с почерка на вашия бранд",
          description:
            "Управлявайте визията и информацията в магазина, без да се налага да го изграждате отначало.",
          features: [
            "Цветове, лого, секции на началната страница и банери",
            "Езици и преведено съдържание на каталога",
            "Валути, контакти, работно време и профили в социалните мрежи",
          ],
        },
      ],
    },
    workflow: {
      eyebrow: "Ясен процес за онлайн търговия",
      title: "От каталога до клиента",
      description:
        "Настройте магазина, улеснете продажбите и го подобрявайте с един ясен работен процес.",
      steps: [
        {
          title: "Подредете каталога",
          description:
            "Организирайте продуктите с категории, марки, варианти, характеристики и наличности.",
        },
        {
          title: "Изградете онлайн магазина",
          description:
            "Настройте визията, началната страница, акцентните продукти, банерите и фирмената информация.",
        },
        {
          title: "Продавайте и изпълнявайте поръчки",
          description:
            "Улеснете търсенето на продукти, плащането и работата с клиентски профили, поръчки и доставки.",
        },
        {
          title: "Анализирайте и подобрявайте",
          description:
            "Използвайте данните за продажбите и клиентите, за да вземате по-добри решения.",
        },
      ],
    },
    cta: {
      title: "Готови ли сте да стартирате своя онлайн магазин?",
      description:
        "Нека създадем онлайн магазин, който увеличава продажбите, печели доверието на клиентите и развива вашия бранд.",
      imageAlt: "Преглед на платформата за електронна търговия WECP",
    },
  },
};

export default bg;
